import { Trans } from "@web-monorepo/i18n/macro";
import { DDSHeadlineText } from "@web-monorepo/dds";
import { useMemo } from "react";
import BedtimeList from "./BedtimeList";
import FixedHeaderScroller from "./BeyondToolkit/FixedHeaderScroller";
import styles from "./ToolkitMenu.module.css";

type ToolkitMenuProps = {
  isPremiumUnlocked: boolean;
  variant: string | string[];
};

function ToolkitMenu({ isPremiumUnlocked, variant }: ToolkitMenuProps) {
  const lockedUrl = useMemo(() => {
    return `/beyondToolkit?isPremiumUnlocked=${isPremiumUnlocked}&variant=${variant.toString()}`;
  }, [isPremiumUnlocked, variant]);

  return (
    <FixedHeaderScroller
      header={
        <div className={styles.header}>
          <DDSHeadlineText as="h2">
            <Trans>Bedtime</Trans>
          </DDSHeadlineText>
        </div>
      }
    >
      <div className={styles.list}>
        <BedtimeList isPremiumUnlocked={isPremiumUnlocked} lockedUrl={lockedUrl} />
      </div>
    </FixedHeaderScroller>
  );
}

export default ToolkitMenu;
